import { render, staticRenderFns } from "./BrowserCamera.vue?vue&type=template&id=0af9487f&lang=pug&"
import script from "./BrowserCamera.vue?vue&type=script&lang=ts&"
export * from "./BrowserCamera.vue?vue&type=script&lang=ts&"
import style0 from "./BrowserCamera.vue?vue&type=style&index=0&id=0af9487f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports